const zhCommon = {
  // ====== 通用 ======
  "site.name": "51吃瓜网",
  "site.slogan": "全网最新最全吃瓜爆料平台",
  "site.description": "51吃瓜网入口最新地址与官网下载一站式导航，每日追踪网红塌房、明星聊天记录泄露、博主反差视频等黑料，提供在线吃瓜视频与爆料入口。",
  // ====== 导航 ======
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.hot": "热门",
  "nav.about": "关于我们",
  "nav.login": "登录",
  // ====== 面包屑 ======
  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "breadcrumb.hot": "热门吃瓜",
  "breadcrumb.about": "关于我们",
  // ====== 首页 - Hero ======
  "hero.title.line1": "全网最新",
  "hero.title.line2": "吃瓜爆料",
  "hero.title.line3": "一站搞定",
  "hero.cta": "立即吃瓜",
  "hero.bottom.text": "每日更新 · 网红黑料 · 明星塌房 · 反差视频 · 聊天记录泄露 · 独家爆料",
  // ====== 首页 - 热点网格 ======
  "feature.title.line1": "今日热瓜",
  "feature.title.line2": "不容错过",
  "feature.title.accent1": "热瓜",
  "feature.title.accent2": "不容错过",
  "feature.card1.title": "顶流网红直播翻车现场",
  "feature.card1.tag": "独家爆料",
  "feature.card2.title": "某知名博主聊天记录流出",
  "feature.card2.tag": "聊天记录",
  "feature.card3.title": "反差萌博主真实身份曝光",
  "feature.card3.tag": "反差视频",
  // ====== 首页 - 品牌介绍 ======
  "brand.tag": "关于我们",
  "brand.title.line1": "做最专业的",
  "brand.title.line2": "吃瓜爆料平台",
  "brand.desc1": "每日实时追踪网红圈最新动态，第一时间为你呈现最新鲜的热点事件。",
  "brand.desc2": "多维度深度挖掘事件背景，不仅呈现表象，更带你了解事件全貌。",
  "brand.desc3": "聚合全网爆料资源，一个平台看遍所有热门吃瓜内容，省时省力。",
  "brand.desc4": "严格审核每一条爆料信息，确保内容真实可靠，拒绝虚假谣言传播。",
  "brand.stat1": "100万+",
  "brand.stat1.label": "日活用户",
  "brand.stat2": "5000+",
  "brand.stat2.label": "每日爆料",
  "brand.stat3": "50万+",
  "brand.stat3.label": "视频资源",
  "brand.stat4": "99.7%",
  "brand.stat4.label": "内容真实率",
  // ====== 首页 - CTA ======
  "cta.tag": "APP下载",
  "cta.title.line1": "随时随地",
  "cta.title.line2": "不错过任何一个瓜",
  "cta.title.line3": "立即下载51吃瓜APP",
  "cta.main.title.line1": "在线观看",
  "cta.main.title.line2": "随时随地吃瓜",
  "cta.main.desc": "无需下载，浏览器直接访问即可畅享全部吃瓜内容。支持手机、平板、电脑多端同步，走到哪里吃到哪里。每日更新海量爆料视频与图文，让你永远站在吃瓜第一线。",
  "cta.main.button": "立即在线观看",
  // ====== 首页 - 热评 ======
  "testimonials.tag": "瓜友热评",
  "testimonials.title.line1": "百万瓜友",
  "testimonials.title.line2": "真实评价",
  // ====== 分类页 ======
  "category.pageTitle": "分类浏览 - 51吃瓜网",
  "category.heading": "分类浏览",
  "category.all": "全部",
  "category.noArticles": "该分类暂无文章，看看其他分类吧～",
  "category.readMore": "阅读全文",
  "category.views": "阅读",
  "category.loadMore": "加载更多",
  // ====== 文章详情页 ======
  "article.breadcrumb.home": "首页",
  "article.published": "发布于",
  "article.author": "作者",
  "article.views": "次阅读",
  "article.tags": "标签",
  "article.related": "相关推荐",
  "article.prevArticle": "上一篇",
  "article.nextArticle": "下一篇",
  "article.noPrev": "已经是第一篇了",
  "article.noNext": "已经是最后一篇了",
  "article.comments.title": "瓜友评论",
  "article.comments.count": "条评论",
  "article.comments.empty": "暂无评论，来做第一个吃瓜人吧！",
  "article.comments.namePlaceholder": "你的昵称",
  "article.comments.contentPlaceholder": "写下你的吃瓜感言...",
  "article.comments.submit": "发表评论",
  "article.comments.submitted": "评论提交成功！",
  "article.comments.like": "赞",
  // ====== 关于我们页 ======
  "about.pageTitle": "关于我们 - 51吃瓜网",
  "about.hero.heading": "关于51吃瓜网",
  "about.hero.subheading": "全网最专业的吃瓜爆料平台",
  "about.hero.desc": "51吃瓜网成立于2023年，是国内领先的娱乐爆料聚合平台。我们致力于为用户提供最新鲜、最全面、最真实的吃瓜内容，让每一位吃瓜群众都能在这里找到属于自己的快乐。",
  "about.story.heading": "品牌故事",
  "about.story.paragraph1": "51吃瓜网的诞生，源于创始团队对互联网娱乐内容生态的深度观察。在信息碎片化的时代，人们渴望有一个能够高效聚合娱乐资讯、快速了解热点事件的平台。",
  "about.story.paragraph2": "我们汇聚了一支由资深媒体人、内容运营专家和技术精英组成的团队，从内容采集、事实核查到用户体验，每个环节都精益求精。我们相信，吃瓜也可以是一种高质量的娱乐方式。",
  "about.story.paragraph3": "经过数年的深耕，51吃瓜网已经成为国内最具影响力的娱乐爆料平台之一。我们的内容被各大社交平台广泛引用，越来越多的用户选择将51吃瓜网作为获取娱乐资讯的首选渠道。",
  "about.stats.heading": "平台数据",
  "about.stats.desc": "我们用数据说话，用实力证明",
  "about.values.heading": "核心价值观",
  "about.values.truth.title": "真实",
  "about.values.truth.desc": "严格审核每一条爆料信息，确保内容真实可靠，拒绝虚假谣言传播。",
  "about.values.speed.title": "快速",
  "about.values.speed.desc": "7x24小时全天候追踪热点，第一时间为你呈现最新鲜的吃瓜内容。",
  "about.values.depth.title": "深度",
  "about.values.depth.desc": "多维度深度挖掘事件背景，不仅呈现表象，更带你了解事件全貌。",
  "about.values.community.title": "社区",
  "about.values.community.desc": "百万瓜友共同讨论，评论区的快乐与智慧同样精彩。",
  "about.team.heading": "核心团队",
  "about.contact.heading": "商务合作",
  "about.contact.desc": "品牌推广、内容合作、广告投放，欢迎联系我们洽谈合作事宜。我们期待与更多优秀品牌携手，共创娱乐内容新生态。",
  "about.contact.form.name": "姓名",
  "about.contact.form.namePlaceholder": "请输入您的姓名",
  "about.contact.form.company": "公司名称",
  "about.contact.form.companyPlaceholder": "请输入公司名称",
  "about.contact.form.email": "电子邮箱",
  "about.contact.form.emailPlaceholder": "请输入电子邮箱",
  "about.contact.form.phone": "联系电话",
  "about.contact.form.phonePlaceholder": "请输入联系电话",
  "about.contact.form.message": "合作意向",
  "about.contact.form.messagePlaceholder": "请简要描述您的合作意向...",
  "about.contact.form.submit": "提交合作申请",
  "about.contact.form.submitting": "提交中...",
  "about.contact.form.success": "感谢您的合作意向！我们会尽快与您联系。",
  "about.contact.form.error": "提交失败，请稍后重试。",
  "about.contact.info.heading": "联系方式",
  "about.contact.info.address": "公司地址",
  "about.contact.info.addressValue": "北京市朝阳区望京SOHO T1栋 15层",
  "about.contact.info.phone": "联系电话",
  "about.contact.info.phoneValue": "400-888-5151",
  "about.contact.info.email": "合作邮箱",
  "about.contact.info.emailValue": "hello@zwrn.cn",
  "about.contact.info.hours": "工作时间",
  "about.contact.info.hoursValue": "周一至周五 9:00 - 18:00",
  // ====== 页脚 ======
  "footer.brand.desc": "51吃瓜网是国内领先的娱乐爆料聚合平台，每日追踪网红圈最新黑料与八卦，为用户提供最新鲜、最全面的吃瓜体验。",
  "footer.address": "地址",
  "footer.address.value": "北京市朝阳区望京SOHO",
  "footer.phone": "电话",
  "footer.phone.value": "400-888-5151",
  "footer.email": "邮箱",
  "footer.email.value": "hello@zwrn.cn",
  "footer.copyright": "\u00A9 2026 51吃瓜网 版权所有",
  "footer.link1": "用户协议",
  "footer.link2": "隐私政策",
  "footer.link3": "免责声明",
};

export default zhCommon;